import React, { useEffect, createElement } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
export function PrivacyPolicy() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://app.termly.io/embed-policy.min.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return <div className="min-h-screen bg-cream" data-id="element-890" data-mp="1iyfks9b9b62z">
      <div className="max-w-4xl mx-auto px-6 pt-32 pb-20" data-id="element-891" data-mp="1e0npd5bel1u1">
        <Link to="/" className="inline-flex items-center gap-2 text-warmBrown/60 hover:text-peach transition-colors mb-8 font-medium" data-id="element-892" data-mp="1e178uqgpbya6">
          <ArrowLeftIcon size={18} data-id="element-893" data-mp="1595cp4do145p" />
          Back to Home
        </Link>

        <div name="termly-embed" data-id="633365d3-04be-4eca-9c99-1a882216d05b" data-type="iframe" data-mp="21q8ds3qbsrap"></div>
      </div>
    </div>;
}